import React from 'react';
import makeStyles from '@mui/styles/makeStyles'; 
import AppImg from '../../assets/images/app.png'
import AppstoreImg from '../../assets/images/appstore2.png';
import Logo from '../../assets/images/logo.png';

const useStyles = makeStyles(theme => ({
    mainDiv:{
        width:'70%',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'space-around',
        padding: '10px 10px',
        marginTop:'10px',
        alignSelf:'center',
        alignItems:'center',
        border: '1px solid #e4e8ed',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 20px)'
        },
        '& img':{
            width:'150px'
        },
        '& span':{
            fontFamily:'inherit',
            marginTop:'20px',
            wordBreak:'break-all'
        }
    },

    innDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        marginTop:'25px',
        cursor:'pointer'
    },
}));

export default function PaymentSuccess() {
    const openAppLink = () => window.open('https://selynk.page.link/5hqM','_blank');
    const classes = useStyles();
    return(
        <div className={classes.mainDiv}>
            <img alt="i-m-g" src={Logo}/>
            <span>Download Selynk App Now to see your reservations and discover many activities for your kids and family</span>
            <div className={classes.innDiv} onClick={openAppLink}>
                <img alt="i-m-g" src={AppstoreImg} style={{width:'150px'}} />
                <img alt="i-m-g" style={{width:'149px'}} src={AppImg} />
            </div>
        </div>
    )
}